import { Button } from "@mui/material";

export function LoadingButton({ 
  loading = false,
  disabled = false,
  children,
  fullWidth = true,
  variant = "contained",
  type = "button",
  ...props 
}) {
  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      loading={loading}
      variant={variant}
      disabled={loading || disabled}
      {...props}
    >
      {children}
    </Button>
  );
}